import { baseTransport } from '@opengov/transport';
import { getServiceURL } from '../transportWrapper';

const ERP_API_ROOT = '/rest/api';

export const erpRequest = (url: string, clientOptions: RequestInit = {}, hostUrl?: string) => {
  if (!url.startsWith('/')) {
    throw new Error('URL must start with a slash');
  }
  const base = getServiceURL(hostUrl || process.env.ERP_API_HOST || '');
  return base.options(clientOptions, true).url(`${ERP_API_ROOT}${url}`);
};

// Uses baseTransport (no tracingPropagate middleware) to avoid CORS rejection
// of the traceparent header by the ERP server. (temporary workaround)
export const baseErpRequest = (url: string, clientOptions: RequestInit = {}, hostUrl?: string) => {
  if (!url.startsWith('/')) {
    throw new Error('URL must start with a slash');
  }
  const host = hostUrl || process.env.ERP_API_HOST || '';
  return baseTransport
    .url(host)
    .options({ credentials: 'same-origin' })
    .accept('application/json')
    .content('application/json')
    .options(clientOptions, true)
    .url(`${ERP_API_ROOT}${url}`);
};
